type DictionaryAction = "save" | "delete";

export function getDictionaryErrorCode(reason: unknown): string {
  if (
    typeof reason === "object" &&
    reason !== null &&
    "code" in reason &&
    typeof reason.code === "string"
  ) {
    return reason.code;
  }
  return "unknown";
}

export function getDictionaryErrorMessage(
  reason: unknown,
  action: DictionaryAction,
): string {
  const code = getDictionaryErrorCode(reason);

  if (code === "permission-denied" || code === "firestore/permission-denied") {
    return "Sözlük izni doğrulanamadı. Oturumu yenileyip tekrar dene.";
  }
  if (code === "unavailable" || code === "firestore/unavailable") {
    return "Sözlük hizmetine şu anda ulaşılamıyor. Bağlantını kontrol edip tekrar dene.";
  }
  if (code === "unauthenticated" || code === "firestore/unauthenticated") {
    return "Oturumun sona ermiş. Yeniden giriş yapıp tekrar dene.";
  }

  return action === "save"
    ? "Kelime sözlüğe eklenemedi. Lütfen tekrar dene."
    : "Kelime sözlükten silinemedi. Lütfen tekrar dene.";
}
